<template>
  <div class="trade-module">
    <van-row>
      <van-col :span="12">
        <div
          class="trade-btn left-btn"
          :class="tradetype == 0 ? 'rise' : ''"
          @click="tobuy()"
        >
          {{ $t('common.buyup') }}
        </div>
      </van-col>
      <van-col :span="12">
        <div
          class="trade-btn right-btn"
          :class="tradetype == 1 ? 'fall' : ''"
          @click="tosell()"
        >
          {{ $t('common.buydown') }}
        </div>
      </van-col>
      <van-col :span="24" style="margin: 20px 0;">
        <div style="font-size: 14px !important; color: #00e6ff !important;margin-top: 5px;">
          {{ $t('option.transaction') }}
        </div>
        <van-field
          readonly
          clickable
          :value="unit"
          class="animated-input"
        >
          <template #right-icon>
            <van-icon name="arrow-down" />
          </template>
        </van-field>
      </van-col>
      <van-col :span="24"  style="margin: 20px 0;">
        <div style="font-size: 14px !important; color: #00e6ff !important;margin-top: 5px;">
          {{ $t('option.quantity') }}
        </div>
        <van-field
          type="number"
          v-model="num"
          class="animated-input"
        >
          <template #right-icon>
            <span>{{ unit }}</span>
          </template>
        </van-field>
      </van-col>
      <van-col :span="24"  style="margin: 20px 0;">
        <div style="font-size: 14px !important; color: #00e6ff !important;margin-top: 5px;">
          {{ $t('option.times') }} (s)
        </div>
        <van-field
          readonly
          clickable
          :value="label"
          class="animated-input"
          @click="showPicker=true"
        >
          <template #right-icon>
             <van-icon name="arrow-down" />
          </template>
        </van-field>
      </van-col>
      <van-col :span="24">
        <p class="desc">
          {{ $t('trade.used') }} {{ parseFloat(fromvalue).toFixed(8) }}
          {{ fromunit }}
        </p>
      </van-col>
      <van-col :span="24">
        <van-button
          class="trade-btn"
          :class="tradetype == 1 ? 'fall' : 'rise'"
          @click="onSubmit"
        >
          <van-loading v-if="posting" /><span v-else>
            {{ tradetype == 0 ? $t('common.buyup') : $t('common.buydown') }}
            {{ safeCoinname }}</span
          >
        </van-button>
      </van-col>
    </van-row>
    <van-popup v-model="showPicker" position="bottom" round>
      <van-picker
        show-toolbar
        :columns="timecols"
        @confirm="onConfirm"
        value-key="label"
        :confirm-button-text="$t('common.confirm')"
        :cancel-button-text="$t('common.cancel')"
        @cancel="showPicker = false"
      />
    </van-popup>
    <van-dialog
      v-model="showconfirm"
      :title="title"
      show-cancel-button
      :confirmButtonText="$t('common.confirm')"
      :cancelButtonText="$t('common.cancel')"
      @confirm="onSubmit1()"
    >
      <div style="padding: 10px 30px">
        <p style="margin-bottom: 20px">
          {{ $t("option.quantity") }}: {{ num }}
        </p>
        <p style="margin-bottom: 20px">{{ $t("option.times") }}: {{ time }}s</p>
      </div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'TradeModules',
  props: ['coinname', 'mPrice', 'mid','symbol'],
  computed: {
    safeCoinname () {
      return this.coinname || ''
    },
    safePrice () {
      return this.mPrice || 'NaN'
    },
    safeMid () {
      return this.mid || null
    },
    safeSymbol() {
      return this.symbol || {};
    },
  },
  watch: {
    coinname (newval) {
      this.ischange = false
      if (this.tradetype == 1) {
        this.fromunit = newval
      } else {
        this.tounit = newval
      }
    },
    mPrice (newval) {
      if (!this.ischange) {
        this.price = newval
        this.toshowBalance()
      }
    },
    mid () {
      this.getMarketBalance()
    }
  },
  data () {
    return {
      tradetype: 0,
      label: null,
      columns: [
        { value: 1, label: this.$t('trade.limitprice') },
        { value: 2, label: this.$t('trade.marketprice') }
      ],
      quicknum: [25, 50, 75, 100],
      fromunit: this.$t('common.unit'),
      fromvalue: 0,
      tounit: null,
      tovalue: 0,
      usrMarketBalance: null,
      showPicker: false,
      price: null,
      num: '',
      money: null,
      value: null,
      posting: false,
      ischange: false,
      /************************/
      hy_price_type:2,
      unit: null,
      show: false,
      showconfirm: false,
      showorderconfirm: false,
      numcolstmp: [1, 3, 5, 10],
      hymin: null,
      numcols: [],
      timecols: [],
      time: null,
      title: null,
      balance: null,
      frm: {
        m_id: null, //	是	int	市场id
        ctime: null, //	是	int	选择的交易时间
        ctzed: null, //	是	int	下注额度
        buytype: null, //
      },
      order_id: null
    }
  },
  mounted () {
    this.tounit = this.safeCoinname
    this.label = 0 //this.columns[0].label
    this.value = 0 // this.columns[0].value
    this.getHyConfig()
  },
  methods: {
    tosell () {
      this.ischange = false
      this.tradetype = 1
      //this.tounit = this.$t('common.unit')
      //this.fromunit = this.safeCoinname
      //this.$emit('change-trade', 1)
      this.toshowBalance()
    },
    tobuy () {
      this.ischange = false
      this.tradetype = 0
      //this.fromunit = this.$t('common.unit')
      //this.tounit = this.safeCoinname
      //this.$emit('change-trade', 0)
      this.toshowBalance()
    },
    btnStep (val) {
      this.ischange = true
      this.price = (parseFloat(this.price) + parseFloat(val)).toFixed(8)
      this.estimationMoney()
      this.toshowBalance()
    },
    inputChange () {
      this.ischange = true
      this.estimationMoney()
    },
    toshowBalance () {
      /*
      if (this.usrMarketBalance && this.usrMarketBalance.usdt_balance) {
        if (this.tradetype == 0) {
          this.fromvalue = this.usrMarketBalance.usdt_balance
        } else {
          this.fromvalue = this.usrMarketBalance.coin_balance
        }
        let tmp_price = this.price
        if (this.value == 2) {
          tmp_price = this.safePrice
        }
        this.tovalue = (
          parseFloat(this.fromvalue) / parseFloat(tmp_price)
        ).toFixed(8)
      }\
      */
    },
    onConfirm (item) {

      this.label = item
      this.time = item
     // this.value = item.value
      this.showPicker = false
    },
    async getMarketBalance () {
      await this.$http({
        method: 'post',
        url: 'getMarketBalance',
        data: { m_id: this.safeMid }
      }).then(res => {
        if (res && res.data) {
          this.usrMarketBalance = res.data
          this.toshowBalance()
        }
      })
    },
    estimationMoney () {
      /*
      let tmp_price = this.price
      if (this.value == 2) {
        tmp_price = this.safePrice
      }
      if (this.num.length > 0) {
        if (this.tradetype == 0) {
          let tmpMoney = parseFloat(tmp_price) * parseFloat(this.num)
          if (parseFloat(tmpMoney) > parseFloat(this.fromvalue)) {
            this.$toast.fail(this.$t('trade.errorMoney'))
            this.money = null
          } else {
            this.money = parseFloat(tmpMoney).toFixed(8)
          }
        } else {
          if (parseFloat(this.num) > parseFloat(this.fromvalue)) {
            this.$toast.fail(this.$t('trade.errorMoney'))
            this.money = null
          } else {
            let tmpMoney = parseFloat(tmp_price) * parseFloat(this.num)
            this.money = parseFloat(tmpMoney).toFixed(8)
          }
        }
      }
      */
    },
    estimationNum () {
      /*
      let tmp_price = this.price
      if (this.value == 2) {
        tmp_price = this.safePrice
      }
      if (this.money.length > 0) {
        let tmpvalue = this.fromvalue
        if (this.tradetype == 1) {
          tmpvalue = this.tovalue
        }

        if (parseFloat(this.money) > parseFloat(tmpvalue)) {
          this.$toast.fail(this.$t('trade.errorMoney'))
          this.num = null
        } else {
          this.num = (parseFloat(this.money) / parseFloat(tmp_price)).toFixed(8)
        }
      }
        */
    },
    quickMoney (item) {
      this.money = (parseFloat(this.fromvalue) * parseFloat(item)) / 100
      this.estimationNum()
    },
    async onSubmit () {
      console.log(this.num > 0)
      console.log(this.time > 0)
      if (this.num > 0 && this.time > 0) {
        this.showconfirm = true;
        this.title = this.tradetype == 0 ? this.$t("common.buyup") : this.$t("common.buydown")
        this.frm.buytype = this.tradetype == 0 ? 1 : 2;
      }
      /*
      if (this.value != 2) {
        if (!(this.price && this.price.length > 0)) {
          this.$toast.fail(this.$t('trade.priceerror'))
          return
        }
      } else {
        if (!(this.money && this.money.length > 0)) {
          this.$toast.fail(this.$t('trade.moneyerror'))
          return
        }
      }
      if (!(this.num && this.num.length > 0)) {
        this.$toast.fail(this.$t('trade.numerror'))
        return
      }

      if (this.posting) {
        return
      }

      const type = this.tradetype == 0 ? 1 : 2

      const frm = {
        m_id: this.safeMid,
        num: this.num,
        price: this.price,
        operate_type: this.value,
        amount: this.money,
        type: type
      }
      this.posting = true
      await this.$http({
        method: 'post',
        url: 'upbbbuy',
        data: frm
      })
        .then(res => {
          this.posting = false
          this.$toast.success(res.msg)
          this.num = null
          this.money = null
          this.getMarketBalance()
          // 刷新页面记录列表
          if (this.value == 1) {
            this.$emit('reset-record', type)
          }
        })
        .catch(() => {
          this.posting = false
        })
        */
      },
    /************************/
    async getHyConfig() {
      await this.$http({
        method: "post",
        url: "getHyConfig",
      }).then((res) => {
        console.log(res);
        this.numcolstmp = res.data.hy_numcolstmp
        this.hy_price_type = res.data.hy_price_type
        this.unit = res.data.coinname;
        this.balance = res.data.balance;
        this.timecols = res.data.hytime;
        this.hymin = res.data.hymin;
        this.initSelectItems(0);
      });
    },
    initSelectItems(index) {
      //this.time = this.timecols[index];
      const tmp = this.hymin[index];
      if(this.hy_price_type == 2){
        this.numcols = [];
        this.numcolstmp.forEach((item) => {
          this.numcols.push((parseFloat(item) * parseFloat(tmp)).toFixed(2));
        });
       // this.num = this.numcols[0];
      } else {
        this.numcols =this.hymin
      }
    },
    async onSubmit1(){
      this.frm.m_id = this.safeMid;
      this.frm.ctime = this.time;
      this.frm.ctzed = this.num;
      await this.$http({
        method: "post",
        url: "creatorder",
        data: this.frm,
      }).then((res) => {
        this.order_id = res.data.order_id;
        this.$toast.success(res.msg);
        this.$emit('reset-usrorder')
      });
    },
  }
}
</script>

<style></style>
